import { useMutation } from "@tanstack/react-query";

import { SpotToast } from "@/components/SpotToast";
import { TablesService } from "@/generated";
import { downloadBlob } from "@/utils/csv";
import { useSpotUser } from "@/utils/spotUser";

export function useExportTableCsv() {
  const { spotGroup } = useSpotUser();

  return useMutation({
    mutationFn: async (table: { id: string; name: string }) => {
      const { data } = await TablesService.exportTableCsv({
        path: { group_id: spotGroup.id, table_id: table.id },
        responseType: "blob",
      });
      downloadBlob(`${table.name || "table"}.csv`, data as Blob);
    },
    onError: () => SpotToast.error("Failed to export table"),
  });
}
